import type {
  ApiResponse,
  CreateWithdrawalLimitRequest,
  UpdateWithdrawalLimitRequest,
  WithdrawalLimit
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class WithdrawalLimitService {
  async getCurrentLimit(): Promise<ApiResponse<WithdrawalLimit>> {
    return apiManager.get<WithdrawalLimit>('/api/v1/admin/withdrawal-limits');
  }

  async getAllLimits(): Promise<ApiResponse<WithdrawalLimit[]>> {
    return apiManager.get<WithdrawalLimit[]>('/api/v1/admin/withdrawal-limits/list');
  }

  async createLimit(data: CreateWithdrawalLimitRequest): Promise<ApiResponse<WithdrawalLimit>> {
    return apiManager.post<WithdrawalLimit>('/api/v1/admin/withdrawal-limits', data);
  }

  async updateLimit(data: UpdateWithdrawalLimitRequest): Promise<ApiResponse<WithdrawalLimit>> {
    return apiManager.put<WithdrawalLimit>('/api/v1/admin/withdrawal-limits', data);
  }
}

export const withdrawalLimitService = new WithdrawalLimitService();
